import { effect, inject, Injectable, signal } from '@angular/core'
import { ActivatedRoute, NavigationStart } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  activatedRoute = inject(ActivatedRoute)
  public isCollapsed = signal<boolean>(!!this.lsValue)
  constructor() {
    effect(() => {
      localStorage.setItem('menuIsCollapsed', JSON.stringify(this.isCollapsed()))
    })
  }
  get lsValue() {
    return JSON.parse(localStorage.getItem('menuIsCollapsed') || 'null')
  }

  onChangeRoute(event: NavigationStart | ActivatedRoute) {
    let url = event.url as string
    if (event instanceof ActivatedRoute) {
      url = event.snapshot.url.toString()
    }

    if (!url) return

    if (url.includes('report') || url.includes('registration-journal')) {
      this.openHandler('reports')
    } else if (
      url.includes('idea') ||
      url.includes('showcase') ||
      url.includes('banner') ||
      url.includes('securities-collections') ||
      url.includes('image')
    ) {
      this.openHandler('showcase')
    } else if (url.includes('recommendations')) {
      this.openHandler('recommendations')
    } else if (url.includes('ipo')) {
      this.openHandler('ipo')
    } else if (url.includes('event')) {
      this.openHandler('events')
    } else if (url.includes('route4?')) {
      this.openHandler('sub4')
    } else if (url.includes('repo/deals') || url.includes('repo/orders')) {
      this.openHandler('repo')
    }
  }

  openMap: Record<string, boolean> = {
    reports: false,
    showcase: false,
    recommendations: false,
    sub4: false,
    events: false,
    ipo: false,
    repo: false,
  }
  openHandler(value: string): void {
    for (const key in this.openMap) {
      this.openMap[key] = false
    }
    this.openMap[value] = true
  }

  onCollapsedChange(): void {
    this.isCollapsed.update(v => !v)
  }
}
